import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import BreadcrumbNav from "@/components/BreadcrumbNav";
import ContactForm from "@/components/ContactForm";
import CTASection from "@/components/CTASection";
import { COUNTIES, slugToCity } from "@/data/serviceAreas";
import { MapPin } from "lucide-react";

const BREADCRUMBS = [{ label: "Home", to: "/" }, { label: "Service Areas" }];

export default function ServiceAreas() {
  return (
    <>
      <SEO
        title="Service Areas | Black Ridge Construction Austin TX"
        description="Black Ridge Construction serves Austin and Central Texas — Travis, Williamson, Hays, Bastrop, and Caldwell counties plus parts of Burnet, Blanco, Llano, Lampasas, and Fayette. View all city pages."
      />

      <section className="bg-br-black text-white">
        <div className="container-br py-12 lg:py-16">
          <BreadcrumbNav dark items={BREADCRUMBS} />
          <div className="max-w-3xl mt-5">
            <div className="br-eyebrow text-br-bronze-2">Service Areas</div>
            <h1 className="br-headline text-4xl sm:text-5xl mt-3">Serving Austin & Central Texas</h1>
            <p className="mt-4 text-gray-300">Black Ridge Construction works with homeowners and property managers throughout the Austin metro and surrounding Central Texas communities. We handle roofing, remodeling, additions, repairs, exterior work, and ongoing maintenance across our service area.</p>
          </div>
        </div>
      </section>

      <section className="section-pad bg-br-paper">
        <div className="container-br grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8 space-y-8">
            {COUNTIES.map((county) => (
              <div key={county.name} className="bg-white p-6 rounded border border-gray-200">
                <h2 className="font-display text-xl tracking-widest uppercase mb-1">{county.name}</h2>
                <div className="divider-bronze" />
                <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-2">
                  {county.cities.map((slug) => (
                    <Link key={slug} to={`/service-areas/${slug}`} className="flex items-center gap-2 text-sm py-1.5 px-3 rounded border border-transparent hover:border-br-bronze hover:bg-br-paper transition">
                      <MapPin size={12} className="text-br-bronze shrink-0" />
                      <span>{slugToCity(slug)}, TX</span>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <aside className="lg:col-span-4 space-y-4">
            <div className="bg-white p-6 rounded border border-gray-200 lg:sticky lg:top-24">
              <h3 className="font-display tracking-widest uppercase text-base mb-3">Request a Consultation in Your Area</h3>
              <ContactForm variant="compact" source_page="service-areas" showContactMethod={false} showTimeline={false} />
            </div>
          </aside>
        </div>
      </section>

      <CTASection />
    </>
  );
}
